import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect } from 'react';
import Modal from '../Modal/Modal';
// import PropTypes from 'prop-types';
import { StyledWrapper, StyledButton, StyledModalHeader, StyledModalDiv, StyledModalSubheader, StyledModalText } from './ProductBundleSizeGuideStyles';

var _ref = React.createElement(
  StyledModalHeader,
  null,
  'Size Guide'
);

var _ref2 = React.createElement(
  StyledModalDiv,
  null,
  React.createElement(
    StyledModalSubheader,
    null,
    'TWIN/TWIN XL'
  ),
  React.createElement(
    StyledModalText,
    null,
    'One 68-inch x 92-inch Comforter and One Standard Sham: 20-inch x 26-inch - Fits both Twin and Twin XL beds'
  )
);

var _ref3 = React.createElement(
  StyledModalDiv,
  null,
  React.createElement(
    StyledModalSubheader,
    null,
    'FULL/QUEEN'
  ),
  React.createElement(
    StyledModalText,
    null,
    'One 88-inch x 90-inch Comforter and Two Standard Shams: 20-inch x 26-inch - Fits both Full and Queen beds'
  )
);

var ProductBundleSizeGuide = function ProductBundleSizeGuide(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalActive = _useState2[0],
      setModalActive = _useState2[1];

  var handleCloseModal = function handleCloseModal() {
    setModalActive(false);
  };
  return React.createElement(
    StyledWrapper,
    null,
    React.createElement(
      StyledButton,
      { onClick: function onClick() {
          return setModalActive(true);
        } },
      'Size Guide'
    ),
    React.createElement(
      Modal,
      {
        className: 'product-size-guide-modal',
        active: modalActive,
        closeModalFunc: handleCloseModal,
        modalHeight: '500px',
        modalWidth: '320px'
      },
      _ref,
      _ref2,
      _ref3
    )
  );
};

ProductBundleSizeGuide.propTypes = {
  // sizeGuideClicked: PropTypes.bool
};

export default ProductBundleSizeGuide;